import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Automatically scroll to the top of the page whenever the route changes.
 * Place inside <BrowserRouter> above the routes.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
